import Cookie from 'js-cookie';

export const UPSELL_COOKIE_V1 = 'upsell_cookie_dismissed_at';
export const UPSELL_COOKIE_V2 = 'upsell_v2_cookie_dismissed_at';
export const RIPPLING_PAYROLL_COOKIE = 'rippling_payroll_banner_dismissed_at';
export const PAYROLL_PROMOTIONAL_BANNER_COOKIE = 'payroll_promotional_banner_dismissed_at';
export const RIPPLING_TIMESHEETS_BANNER_COOKIE = 'rippling_timesheets_banner_dismissed_at';
export const RIPPLING_PAYROLL_NOV_SEASON_BANNER_COOKIE = 'rippling_payroll_nov_season_banner_dismissed_at';
export const RIPPLING_PAYROLL_DEC_SEASON_BANNER_COOKIE = 'rippling_payroll_dec_season_banner_dismissed_at';
export const WIW_DEMO_BANNER_COOKIE = 'wiw_demo_banner_dismissed_at';

const UPSELL_COOKIE_EXPIRATION_DAYS = 30;

export function setUpsellCookie(date: string, cookieName: string, expirationDays?: number) {
  Cookie.set(cookieName, date, { expires: expirationDays || UPSELL_COOKIE_EXPIRATION_DAYS });
}

export function getUpsellCookie(cookieName: string) {
  return Cookie.get(cookieName);
}
